/** Qué caduca (#14017), en español. */
export const EXPIRY_CATEGORY_LABELS: Record<string, string> = {
	CERTIFICATE: "Certificado",
	DOMAIN: "Dominio",
	SUPPLIER: "Proveedor crítico",
	OTHER: "Otro",
};
